import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { userPermissions } from '@/common/constants'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'
import { refundStatuses } from '@/returns/constants'
import { getSumOfSelectedConcepts } from '@/returns/helpers/helpers'
import { getEditTransactionResultMenuItems } from '@/returns/pages/TransactionValidationPage/helpers'

const useEditTransactionResultDrawer = ({
  storeId,
  setRefundMethod,
  setNote,
  setConcepts,
  changeOriginalTransaction,
  resetTransaction,
}) => {
  const { t } = useTranslation()
  const { hasPermission } = useUserPermissions()
  const [showEditTransactionResultDrawer, setShowEditTransactionResultDrawer] = useState(false)
  const shouldSendModifications = useRef(false)

  const canEditTransactionTotal = hasPermission(userPermissions.editTransactionTotal, storeId)

  const openEditTransactionResultDrawer = () => {
    setShowEditTransactionResultDrawer(true)
  }

  const closeEditTransactionResultDrawer = () => {
    setShowEditTransactionResultDrawer(false)
  }

  const onSaveEditTransactionResult = ({ transactionConcepts, refundMethodSelected, note }) => {
    setRefundMethod(refundMethodSelected)
    setNote(note)
    setConcepts(transactionConcepts)
    closeEditTransactionResultDrawer()
    shouldSendModifications.current = true

    const conceptsAmount = getSumOfSelectedConcepts(transactionConcepts.filter(concept => concept?.selected))

    if (conceptsAmount > 0) {
      changeOriginalTransaction(data => {
        return {
          ...data,
          permissions: {
            ...data.permissions,
            allows_issue_refund: true,
          },
          summary: {
            ...data.summary,
            refund_status: refundStatuses.pending,
          },
        }
      })
    } else {
      resetTransaction()
    }
  }

  const editPendingPaymentMenuItems = getEditTransactionResultMenuItems({
    label: t('Editar pago pendiente'),
    canEditTransactionTotal,
    onClick: openEditTransactionResultDrawer,
  })

  const editRefundMenuItems = getEditTransactionResultMenuItems({
    label: t('Editar reembolso'),
    canEditTransactionTotal,
    onClick: openEditTransactionResultDrawer,
  })

  return {
    showEditTransactionResultDrawer,
    closeEditTransactionResultDrawer,
    canEditTransactionTotal,
    editPendingPaymentMenuItems,
    editRefundMenuItems,
    shouldSendModifications,
    onSaveEditTransactionResult,
  }
}

export default useEditTransactionResultDrawer
